// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".63f451f9492a57aa4acb7331c594beeb98391767.chunk.bundle.js";
};